<template>
  <ModalDialog :show="showModal && !modalHasBeenHidden && !isAuthenticated" @close="closeModal()">
    <div class="loop-modal" v-show="mode === 'free'">
      <!-- <h3 class="loop-modal-title">¡Te regalamos HelloBB Premium!</h3>
      <div class="loop-modal-content">
          Crea una lista <span>para ti</span> y obtén la versión Premium de la mejor wishlist multi-tienda.
      </div>
      <div class="loop-modal-image">
        <img src="../../../assets/images/hellobb-premium-banner-2.png" alt="Landing Premium Free" />
      </div> -->
      <h3 class="loop-modal-title">🎁 ¡Te regalamos HelloBB Premium!</h3>
      <p class="loop-modal-content">
          <span v-html=" $t('guest.loop.morethan') "></span>
      </p>
      <div class="loop-modal-content-points">
        <span>✅ {{ $t("guest.loop.bullet1") }}</span>
        <span>🛍️ {{ $t("guest.loop.bullet2") }}</span>
        <span>📊 {{ $t("guest.loop.bullet3") }}</span>
      </div>
      <button class="button button--primary" @click="claimOffer">Obtén Premium gratis</button>
    </div>
    <div class="loop-modal" v-show="mode === 'default'">
      <!-- <h3 class="loop-modal-title">{{ $t("guest.loop.title") }}</h3>
      <div class="loop-modal-content">
          {{ $t("guest.loop.description") }}
      </div>
      <div class="loop-modal-image">
        <img src="../../../assets/images/loop-guest-banner-EN-2.png" alt="Create your own list" />
      </div> -->
      <h3 class="loop-modal-title">⭐ {{ $t("guest.loop.title") }}</h3>
      <p class="loop-modal-content">
          <span v-html=" $t('guest.loop.morethan') "></span>
      </p>
      <div class="loop-modal-content-points">
        <span>✅ {{ $t("guest.loop.bullet1") }}</span>
        <span>🛍️ {{ $t("guest.loop.bullet2") }}</span>
        <span>📊 {{ $t("guest.loop.bullet3") }}</span>
      </div>
      <button class="button button--primary" @click="claimOffer">{{ $t("guest.loop.cta") }}</button>
    </div>
  </ModalDialog>
</template>

<script>
import { mapGetters } from "vuex";
import ModalDialog from "../../../components/ui/ModalDialog.vue";
import { setNotShowDate, getNotShowDate } from "../../../plugins/promocode.js";

export default {
  name: "LoopModal",
  components: { ModalDialog },
  data() {
    return {
      showModal: false,
      notShowDate: null
    };
  },
  computed: {
    ...mapGetters({
      openLoopModal: "openLoopModal",
      guestCountry: "guestCountry",
      countryCode: "countryCode",
      isAuthenticated: "isAuthenticated"
    }),
    mode() {
      if (this.guestCountry.toLowerCase() === 'es') {
        return 'free';
      }
      return 'default';
    },
    modalHasBeenHidden() {
      return this.notShowDate && new Date(this.notShowDate) > new Date();
    },
  },
  methods: {
    claimOffer() {
      //window.mixpanel.stop_session_recording();
      window.mixpanel.track("Clicar Loop Modal CTA", { mode: this.mode });
      this.notShowDate = setNotShowDate("guest_loop", 3);
      if(this.mode === "free") window.location.href = "/landing/premium-free?utm_source=loop-guest-free-modal";
      else window.location.href = "/" + "?utm_source=loop-guest-modal";
    },
    closeModal() {
      //window.mixpanel.stop_session_recording();
      window.mixpanel.track("Tancar Loop Modal");
      this.showModal = false;
      document.body.classList.remove("modal-open");
      this.$store.commit("setOpenLoopModal", false);
      this.notShowDate = setNotShowDate("guest_loop", 3);
      this.$emit('close');
    }
  },
  mounted() {
    this.notShowDate = getNotShowDate("guest_loop");
    // if (this.openLoopModal) {
    //   this.showModal = true;
    //   if(!this.modalHasBeenHidden) {
    //     document.body.classList.add("modal-open");
    //     //window.mixpanel.start_session_recording();
    //     window.mixpanel.track("Obrir Loop Modal");
    //     console.log("Opening Loop Modal from mounted");
    //   }
    // }
  },
  watch: {
    openLoopModal(newVal) {
      this.showModal = newVal;
      if(newVal && !this.modalHasBeenHidden) {
        document.body.classList.add("modal-open");
        //window.mixpanel.start_session_recording();
        window.mixpanel.track("Obrir Loop Modal");
        console.log("Opening Loop Modal from watcher");
      }
    }
  }
};
</script>

<style scoped>
.loop-modal {
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.loop-modal-title {
    font-weight: 600;
    color: #1e0028;
    font-size: 2rem;
    flex: 0 0 auto;
}

.loop-modal-content {
  font-size: 1.12rem;
}

.loop-modal-content-points {
  text-align: left;
  margin: 0 auto;
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  font-size: 0.9rem;
}

.loop-modal-content-points span {
  margin-bottom: 0;
}

.loop-modal button {
  max-width: 400px;
  margin: 0 auto;
  flex: 0 0 auto;
}

.loop-modal-image {
  width: 300px;
  height: auto;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  margin-bottom: -1.5rem;
}

.loop-modal-image img {
  max-width: 100%;
  height: auto;
  max-height: 60vh;
  object-fit: contain;
}
.loop-modal button {
    width: 100%;
  }

@media screen and (max-width: 768px) {
  .loop-modal {
    padding: 0rem;
    gap: 1rem;
  }
  .loop-modal-title {
    font-size: 2rem;
    line-height: 1.4;
    margin-bottom: 0.5rem;
    margin-top: 0.5rem;
  }
  .loop-modal button {
    width: 100%;
  }
  .loop-modal-image {
    width: 100%;
  }
  .loop-modal-image img {
    max-height: 60vh;
  }
  .loop-modal-content-points {
    margin: 0 1rem;
  }
}
</style>
